import { IAccount } from '../services';

export const getPersonalEnvName = (hostName: string): string => {
  if (hostName === 'localhost') {
    return hostName;
  }

  const alias: string = hostName.split('.')[0];

  return alias.includes('-') ? alias.split('-')[1] : '';
};

export const createUrlToImpersonate = (marketplaceUrl: string): string => {
  const personalEnvName: string = getPersonalEnvName(window.location.hostname);
  if (personalEnvName.length === 0 || personalEnvName === 'localhost') {
    return marketplaceUrl;
  }

  const urlSegments: string[] = marketplaceUrl.split('.');
  urlSegments[0] = `${urlSegments[0]}-${personalEnvName}`; // still using 'hub' alias for feature environments

  return urlSegments.join('.');
};

export const getSystemName = (hostName: string): string => {
  if (hostName === 'localhost') {
    return hostName;
  }
  const alias: string = hostName.split('.')[0];
  return alias.includes('admin') ? 'marketplace' + alias : alias;
};
export function isLessThan30MinutesAgo(date: number): boolean {
  const thirtyMinutesInMilliseconds = 60 * 30;
  return date > Math.floor(Date.now() / 1000) - thirtyMinutesInMilliseconds;
}

export function hasSelfSignup(account: IAccount) {
  return account.isHubSelfSignup;
}

export function isStandardAccount(account: IAccount): boolean {
  return account.accountTier === 'Standard';
}

export function isLegacyECommAccount(account: IAccount): boolean {
  return account.accountTier === 'LegacyEComm';
}

export function isEnterpriseAccount(account: IAccount): boolean {
  return account.accountTier === 'Enterprise';
}

/**
 * accountTier is undefined until the account has loaded; callers that gate UI on
 * tier must treat that as unresolved rather than as "not X".
 */
export function isAccountTierResolved(account: IAccount): boolean {
  return !!account?.accountTier;
}

/**
 * Standard and LegacyEComm accounts bill a card stored on the account (Finance
 * billing account) and can manage it in the payment widget. Enterprise accounts
 * are invoiced. Single decision shared by the Billing page and any banner that
 * sends the user there.
 */
export function canManagePaymentMethod(account: IAccount): boolean {
  return (
    account?.accountTier === 'Standard' ||
    account?.accountTier === 'LegacyEComm'
  );
}
